import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4 whitespace-nowrap">
            平台特色
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            为什么选择43423漫画网
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">五大核心优势，打造极致的漫画阅读体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/70 p-5 md:p-6 text-center hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 rounded-full bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}